import React from "react"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import FieldProto from "../../../../../../proto/field-proto"
import {ItemModelV2_CalculatedValues} from "../../../../../../../model2/item2/calculated/@type"
import TasksView_Column from "../../../../../../../model2/column/column"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    onMouseEnter    : callback
    onMouseLeave    : callback
}

export default function FieldAttachmentsTotal_TableCellCalculated_Hovered(props: Props) {

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

    const showSummaryView   = /*props.listItem.isGroup ||*/ props.listItem.view.isCollapsed
    const showChildren      = showSummaryView && !!calculatedValues?.children.value && calculatedValues?.children.value > 0
    const showOwnValue      = ownValue > 0
    const showPlus          = showOwnValue && showChildren

    return (
        <div className      = "cell-flex is-hovered ui5-txt-less-important-small"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            <div className="ui5-field-editable size-small w-100-percent h-100-percent">

                <div className="flex-row-left-center truncate">
                    {showOwnValue &&
                        <>
                            <div className={Classes("ui5-ico-13 m-r-5 m-t-1 i5-attachment")}/>
                            <div className="ui5-txt-less-important-small">
                                {ownValue}
                            </div>
                        </>
                    }

                    {showPlus &&
                        <div className="ui5-txt-less-important-small m-r-5 m-l-5">+</div>
                    }

                    {showChildren &&
                        <>
                            <div className="ui5-ico-12 i5-folder-tree m-r-5 m-t-1"/>
                            <div className="ui5-txt-less-important-small">
                                {calculatedValues?.children.value}
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}
